import React from 'react'
import "./Logo.css";
import { Link } from 'react-router-dom';

const Logo = ({ clearFilters, setMenuOpen, darkmodeClass }) => {
  const handleLogoClick = () => {
    clearFilters();

    if (typeof setMenuOpen === 'function') {
      setMenuOpen(false);
    }
  };
  return (
    <div>
      <div className="logo-container">
        <Link to="/" exact className={`logo ${darkmodeClass}`} onClick={handleLogoClick}>Pixabay</Link>
      </div>
    </div>
  )
}

export default Logo
